// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"873bbeaf","160":"5ba2182d","312":"d7b17e1c","718":"37dd6b6a"}[chunkId] + ".chunk.js";
};